'use strict'
import superagentDefaults from 'superagent-defaults'

var superagent = superagentDefaults()

export default function () {
  var apiUrl = process.env.VUE_APP_NATIVEHASH_SYSTEM_URL

  function setPostMultiForm (url, token, data) {
    const request = superagent.post(url)

    for (const key in data) {
      if (data[key] instanceof File) {
        request.attach(key, data[key])
      } else if (Array.isArray(data[key])) {
        request.field(key + '[]', data[key])
      } else if (typeof data[key] === 'object' && data[key] !== null) {
        for (const subKey in data[key]) {
          const val = data[key][subKey]
          if (val !== null && val !== undefined) {
            request.field(`${key}[${subKey}]`, val)
          }
        }
      } else if (data[key] !== null && data[key] !== undefined) {
        request.field(key, data[key])
      }
    }

    return request
      .set('Authorization', `Bearer ${token}`)
      .accept('json')
  }

  return {
    getAvailableLangs () {
      const url = apiUrl + '/available-langs'

      return superagent
        .get(url)
        .accept('json')
    },
    getDefaultNotificationsConfig (token) {
      const url = apiUrl + '/notifications-config'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    login (email, password) {
      const url = apiUrl + '/users/login'

      return superagent
        .post(url)
        .send({ email, password })
        .accept('json')
    },
    refreshToken (token) {
      const url = apiUrl + '/users/refresh'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    logout (token) {
      const url = apiUrl + '/users/logout'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    userProfile (token) {
      const url = apiUrl + '/my-profile'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editUserEmail (token, data) {
      const url = apiUrl + '/my-profile/edit-email'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editUserLang (token, data) {
      const url = apiUrl + '/my-profile/edit-lang'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editUserNotifications (token, data) {
      const url = apiUrl + '/my-profile/edit-notifications'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    userAccountDelete (token, data) {
      const url = apiUrl + '/my-profile/account-delete'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editUserTypeData (token, data) {
      const url = apiUrl + '/my-profile/edit-data'

      return setPostMultiForm(url, token, data)
    },
    editUserPassword (token, data) {
      const url = apiUrl + '/my-profile/edit-password'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editContractData (token, data) {
      const url = apiUrl + '/my-profile/edit-contract-data'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    addInfluencerPicture (token, data) {
      const url = apiUrl + '/my-profile/img/add'

      return setPostMultiForm(url, token, data)
    },
    deleteInfluencerPicture (token, hash) {
      const url = apiUrl + '/my-profile/img/del'

      return superagent
        .post(url)
        .send({ hash_name: hash })
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    sendPasswordResetLink (data) {
      const url = apiUrl + '/users/send-reset-link'

      return superagent
        .post(url)
        .send(data)
        .accept('json')
    },
    resetPassword (data) {
      const url = apiUrl + '/users/reset-password'

      return superagent
        .post(url)
        .send(data)
        .accept('json')
    },
    registerNewUser (data) {
      const url = apiUrl + '/users/register'

      return superagent
        .post(url)
        .send(data)
        .accept('json')
    },
    verifyRegisterEmail (hash) {
      const url = apiUrl + '/users/register/verify/' + hash

      return superagent
        .get(url)
        .accept('json')
    },
    getChannelsTypesList (token) {
      const url = apiUrl + '/channels-types'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getChannelList (token) {
      const url = apiUrl + '/my-channels/list'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    addChannel (token, data) {
      const url = apiUrl + '/my-channels/add'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    deleteChannel (token, id) {
      const url = apiUrl + '/my-channels/delete/' + id

      return superagent
        .delete(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    analyticsChannelAccessGetLink (token, id) {
      const url = apiUrl + '/my-channels/analytics-access/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    analyticsSaveStats (token, id, data) {
      const url = apiUrl + '/my-channels/analytics-save/' + id

      return setPostMultiForm(url, token, data)
    },

    search (token, data) {
      const url = apiUrl + '/search/influencers'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getSearchFiltersData (token) {
      const url = apiUrl + '/search/filters-data'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    searchContactWanted (token, data) {
      const url = apiUrl + '/search/contact-wanted'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    favlist (token) {
      const url = apiUrl + '/favlist'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    favlistAdd (token, data) {
      const url = apiUrl + '/favlist/add'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    favlistDelete (token, influencerId) {
      const url = apiUrl + '/favlist/delete/' + influencerId

      return superagent
        .delete(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    campaignsAdvertiser (token) {
      const url = apiUrl + '/campaigns'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignAdvertiser (token, id) {
      const url = apiUrl + '/campaigns/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignAdvertiserPrice (token, id) {
      const url = apiUrl + '/campaigns/price/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    addCampaignsAdvertiser (token, data) {
      const url = apiUrl + '/campaigns/add'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editCampaignAdvertiser (token, id, data) {
      const url = apiUrl + '/campaigns/edit/' + id

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    deleteCampaignAdvertiser (token, id) {
      const url = apiUrl + '/campaigns/delete/' + id

      return superagent
        .delete(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    cancelCampaignAdvertiser (token, id) {
      const url = apiUrl + '/campaigns/cancel/' + id

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    startInviteCampaignAdvertiser (token, id) {
      const url = apiUrl + '/campaigns/start-invite/' + id

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    startWithoutFullMembersCampaignAdvertiser (token, id) {
      const url = apiUrl + '/campaigns/start-without-full-members/' + id

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    campaignsInfluencer (token) {
      const url = apiUrl + '/campaigns-i'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignInfluencer (token, id) {
      const url = apiUrl + '/campaigns-i/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getCampaignMembersAdvertiser (token, campaignId) {
      const url = apiUrl + '/campaigns-members-adv/' + campaignId

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    inviteCampaignMember (token, data) {
      const url = apiUrl + '/campaigns-members-adv/invite'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    cancelInvitedCampaignMember (token, memberId) {
      const url = apiUrl + '/campaigns-members-adv/cancel-invite/' + memberId

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignCandidates (token, campaignId) {
      const url = apiUrl + '/campaigns-members-adv/candidates/' + campaignId

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    acceptCampaignInvite (token, campaignId) {
      const url = apiUrl + '/campaigns-members-inf/accept-invite/' + campaignId

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    rejectCampaignInvite (token, campaignId) {
      const url = apiUrl + '/campaigns-members-inf/reject-invite/' + campaignId

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getCampaignMessages (token, memberId) {
      const url = apiUrl + '/campaign-member-messages/' + memberId

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    addCampaignMessages (token, memberId, message) {
      const url = apiUrl + '/campaign-member-messages/' + memberId + '/add'

      return superagent
        .post(url)
        .send({ message })
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    markAsReadedCampaignMessage (token, memberId) {
      const url = apiUrl + '/campaign-member-messages/' + memberId + '/readed'

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getUnread (token) {
      const url = apiUrl + '/campaign-member-messages/unreaded'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getCampaignFiles (token, memberId) {
      const url = apiUrl + '/campaign-member-files/' + memberId

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    addCampaignFiles (token, memberId, data) {
      const url = apiUrl + '/campaign-member-files/' + memberId + '/add'

      return setPostMultiForm(url, token, data)
    },
    acceptCampaignFile (token, fileId) {
      const url = apiUrl + '/campaign-member-files/file/' + fileId + '/accept'

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    rejectCampaignFile (token, fileId, message) {
      const url = apiUrl + '/campaign-member-files/file/' + fileId + '/reject'

      return superagent
        .post(url)
        .send({
          message
        })
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getCampaignReport (token, campaignId) {
      const url = apiUrl + '/campaign-report/' + campaignId

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getCampaignReportInfluencer (token, campaignId) {
      const url = apiUrl + '/campaign-report-i/' + campaignId

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    saveCampaignReportInfluencer (token, campaignId, data) {
      const url = apiUrl + '/campaign-report-i/' + campaignId + '/save'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    campaignsCpcAdvertiser (token) {
      const url = apiUrl + '/campaigns-cpc'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignCpcAdvertiser (token, id) {
      const url = apiUrl + '/campaigns-cpc/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    addCampaignsCpcAdvertiser (token, data) {
      const url = apiUrl + '/campaigns-cpc/add'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    editCampaignsCpcAdvertiser (token, id, data) {
      const url = apiUrl + '/campaigns-cpc/' + id + '/edit'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    deleteCampaignsCpcAdvertiser (token, id) {
      const url = apiUrl + '/campaigns-cpc/' + id + '/delete'

      return superagent
        .delete(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    depositCampaignsCpcAdvertiser (token, id, data) {
      const url = apiUrl + '/campaigns-cpc/' + id + '/deposit'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignCpcFeeAdvertiser (token) {
      const url = apiUrl + '/campaigns-cpc/fee'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignCpcMembersAdvertiser (token, id) {
      const url = apiUrl + '/campaigns-cpc/' + id + '/members'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getBanCampaignCpcMemberAdvertiser (token, memberId, message) {
      const url = apiUrl + '/campaigns-cpc/ban-member/' + memberId

      return superagent
        .post(url)
        .send({ message })
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignCpcReport (token, id) {
      const url = apiUrl + '/campaigns-cpc/' + id + '/report'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    campaignsCpcInfluencer (token) {
      const url = apiUrl + '/campaigns-cpc-i'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getCampaignCpcInfluencer (token, id) {
      const url = apiUrl + '/campaigns-cpc-i/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    joinCampaignsCpcInfluencer (token, id) {
      const url = apiUrl + '/campaigns-cpc-i/' + id + '/join'

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getAdvertiser (token, id) {
      const url = apiUrl + '/advertisers-f/' + id

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getArchetypes (token) {
      const url = apiUrl + '/archetypes'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    setUserArchetypes (token, archetypeId) {
      const url = apiUrl + '/my-profile/set-archetype'

      return superagent
        .post(url)
        .send({
          archetype_id: archetypeId
        })
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getSearchSubscriptionStatus (token) {
      const url = apiUrl + '/my-profile/search-subscription-status'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getThematicCategories (token) {
      const url = apiUrl + '/themtatic-categories'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getPaymentsList (token, filters) {
      const url = apiUrl + '/payments'

      return superagent
        .get(url)
        .query(filters)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getPaymentsBalance (token) {
      const url = apiUrl + '/payments/balance'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getSearchSubscriptionPricelist (token) {
      const url = apiUrl + '/payments/search-subscription-pricelist'

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    newSearchSubscription (token, data) {
      const url = apiUrl + '/payments/new-search-subscription'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    cancelSearchSubscription (token) {
      const url = apiUrl + '/payments/cancel-search-subscription'

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    withdraw (token, data) {
      const url = apiUrl + '/payments/withdraw'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    pay (token, paymentId) {
      const url = apiUrl + '/payments/pay/' + paymentId

      return superagent
        .post(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },

    getSite (token, siteUrl) {
      const url = apiUrl + '/sites/' + siteUrl

      return superagent
        .get(url)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    },
    getPublicSite (siteUrl) {
      const url = apiUrl + '/public/' + siteUrl

      return superagent
        .get(url)
        .accept('json')
    },

    sendContactForm (token, data) {
      const url = apiUrl + '/contact-form'

      return superagent
        .post(url)
        .send(data)
        .set('Authorization', `Bearer ${token}`)
        .accept('json')
    }
  }
}
